import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogClose,
  DialogFooter,
  DialogTitle,
} from "../ui/dialog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { Button } from "../ui/button";
import { Settings } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Separator } from "../ui/separator";
import { UserSettingsForm } from "../forms/user-settings-form";
// import { RecentTransactions } from "../utility/recent-transactions";

export const UserSettingsModal = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button data-settings-trigger variant="ghost" className="group size-8 p-0 rounded-[8px] border border-[rgba(255,255,255,0.06)] bg-[rgba(255,255,255,0.03)] hover:bg-[rgba(255,255,255,0.05)] transition-all duration-200 ease-out">
          <Settings className="w-5 h-5 lg:w-6 lg:h-6 text-[#555] group-hover:text-[#999]  transition-transform duration-200 ease-out" />
        </Button>
      </DialogTrigger>
      <DialogTitle className="sr-only">Settings</DialogTitle>
      <DialogContent
        className="min-h-[500px] max-w-[475px] flex flex-col justify-end"
        aria-describedby={undefined}
      >
        <Card className="shadow-sm">
          <CardContent className="pt-1 px-3">
            <Tabs defaultValue="settings" className="lg:w-[400px]">
              <TabsList className="flex flex-row items-center gap-2">
                <TabsTrigger value="settings">Settings</TabsTrigger>
              </TabsList>
              <Separator />
              <TabsContent value="settings" className="py-4">
                <UserSettingsForm />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
        <DialogFooter>
          <DialogClose asChild>
            <Button className="w-full shadow-xl shadow-black/40 text-xl h-11 rounded-xl">
              Close
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
